import { motion } from "framer-motion";
import { ArrowRight, CalendarClock, ClipboardList, Compass, PackageCheck, Plane } from "lucide-react";
import { useLang } from "../LanguageContext";

const ICONS = [ClipboardList, CalendarClock, PackageCheck, Plane, Compass];

export const HowItWorks = ({ onCtaClick }) => {
  const { t } = useLang();
  return (
    <section id="jak-to-dziala" className="bg-[#0F0F0F] py-20 sm:py-28 border-y border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl mb-14">
          <p className="font-body text-xs font-bold uppercase tracking-[0.22em] text-[#E02020] mb-4">{t.how.overline}</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            {t.how.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-6">
          {t.how.steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`step-${i + 1}`}
                className="relative pl-5 border-l-2 border-[#E02020]/30"
              >
                <span className="font-display text-5xl font-bold text-white/10 leading-none">0{i + 1}</span>
                <Icon className="text-[#E02020] -mt-4 mb-4" size={28} strokeWidth={1.7} />
                <h3 className="font-display text-lg sm:text-xl font-semibold text-white mb-2">{s.title}</h3>
                <p className="text-sm text-[#A3A3A3] leading-relaxed">{s.text}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-14">
          <button
            data-testid="how-cta"
            onClick={onCtaClick}
            className="inline-flex items-center gap-2 bg-[#E02020] hover:bg-[#B91818] text-white font-medium text-base px-8 py-4 rounded-sm transition-colors"
          >
            {t.how.cta} <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};
